
import { useLocationTracking } from "./useLocationTracking";
import { formatCoordinates } from "@/utils/golfUtils";

/**
 * Hook pour calculer la distance parcourue par une balle de golf
 * en utilisant le GPS de l'appareil
 */
export const useGolfBallDistance = () => {
  const {
    startPosition,
    endPosition,
    progress,
    distance,
    isTracking,
    error,
    isGeolocationAvailable,
    permissionGranted,
    startTracking,
    stopTracking,
    resetTracking
  } = useLocationTracking();

  return {
    isGeolocationAvailable,
    permissionGranted,
    startPosition,
    endPosition,
    progress,
    distance,
    isTracking,
    error,
    startTracking,
    stopTracking,
    resetTracking,
    formatCoordinates, // Expose the formatting function
  };
};
